module.exports = __webpack_public_path__ + "img/table.673ac895.png";